import userRoutes from "@/features/users/routes";

import programmeRoutes from "@/features/programme/routes";
import programmeCreateRoutes from "@/features/programme-create/routes";
import programmeSetupRoutes from "@/features/programme-setup/routes";

import scenarioEditorRoutes from "@/features/scenario-editor/routes";
import scenarioAnalyticsRoutes from "@/features/scenario-analytics/routes";
import scenarioCompareRoutes from "@/features/scenario-compare/routes";

import adminRoutes from "@/features/admin/routes";
import catalogueRoutes from "@/features/catalogue/routes";
import assembliesRoutes from "@/features/assemblies/routes";
import notificationRoutes from "@/features/notifications/routes";

export default [
  ...userRoutes,

  ...programmeRoutes,
  ...programmeCreateRoutes,
  ...programmeSetupRoutes,

  ...scenarioEditorRoutes,
  ...scenarioAnalyticsRoutes,
  ...scenarioCompareRoutes,

  ...adminRoutes,
  ...catalogueRoutes,
  ...assembliesRoutes,
  ...notificationRoutes,
];
